import { Title } from '../shared/title/title.tsx';
import './player.css';

function Player() {
    return <div id="last-release-container" className="animated">
            <Title value="Last release" />
            <div id="last-release-container-grid" >
                <div></div>
                <div style={{margin: "auto"}}>
                    <iframe title="Last release"
                        style={{border: "0", width: "350px", height: "442px"}} 
                        src="https://bandcamp.com/EmbeddedPlayer/track=3074647177/size=large/bgcol=333333/linkcol=0f91ff/tracklist=false/transparent=true/" seamless><a href="https://holdmetightband.bandcamp.com/track/silence-before-rebirth-feat-desolated">SILENCE BEFORE REBIRTH feat Desolated by Hold Me Tight</a>
                    </iframe>
                </div>
                <div></div> 
            </div>
        </div>;
}

export {Player}